import React from "react";
import get from "lodash/get";
import { object, number, array } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import CardImage from "../../atoms/card-image";
import PlaceholderImage from "../../atoms/placeholder-image";

import "./card-image-type-2.m.css";

const CardImageType2 = ({ story, headlineLimit, widths = [250, 480, 764] }) => {
  const storyObj = story.story ? story.story : story;
  const slug = storyObj["hero-image-s3-key"];
  const storyImageSlug = get(storyObj, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);
  return (
    <Link href={`/${storyObj.slug}`}>
      <div styleName="wrapper" className="card-image-type-2">
        {storyImageSlug ? (
          <CardImage story={storyObj} defaultWidth={36} aspectRatio={[1, 1]} imageType="image1x1" widths={widths} />
        ) : (
          <PlaceholderImage className={"qt-image-dynamic"} story={storyObj} />
        )}
        <Headline story={storyObj} headerType={20} headerLevel={3} headlineLimit={headlineLimit} />
      </div>
    </Link>
  );
};

export default CardImageType2;

CardImageType2.propTypes = {
  story: object,
  headlineLimit: number,
  widths: array
};
